import type { ReactElement } from 'react';

import { getFileTypeKey } from './file-utils';
import {
  FileCsv,
  FileDefault,
  FileDoc,
  FileImage,
  FilePdf,
  FilePpt,
  FileTxt,
  FileXls,
  FileZip,
} from './icons';

interface FileIconProps {
  className?: string;
  size?: number;
}

const FILE_TYPE_ICON_MAP: Record<string, React.FC<FileIconProps>> = {
  pdf: FilePdf,
  doc: FileDoc,
  xls: FileXls,
  csv: FileCsv,
  ppt: FilePpt,
  txt: FileTxt,
  zip: FileZip,
  image: FileImage,
  default: FileDefault,
};

/**
 * Returns the appropriate file icon component based on file extension or MIME type.
 */
export function getFileIcon(
  filename: string,
  mimeType?: string,
  props?: FileIconProps
): ReactElement {
  const key = getFileTypeKey(filename, mimeType);
  const Icon = FILE_TYPE_ICON_MAP[key] ?? FileDefault;
  return <Icon {...props} />;
}
